<template>
  <div class="addActivities">
    <div class="merchant">
      <el-form ref="form" :model="form" label-width="240px" :rules="rules">
        <div>
          <el-form-item
            label="坐标选择"
            label-position="right"
            class="form-label"
          >
            <el-button @click="coordinate = true">选择坐标</el-button>
          </el-form-item>

          <!-- <el-form-item
            label="酒吧地址"
            label-position="right"
            class="form-label"
            
          > -->
          <div class="coordinate">
            <el-form-item
              label-width="240px"
              label-position="right"
              prop="province"
              label="省份"
            >
              <!-- <span class="merchant-label" slot="label">省份</span> -->
              <el-input v-model="form.province" style="width: 200px"></el-input>
            </el-form-item>
            <el-form-item
              label-width="80px"
              label-position="right"
              prop="cityName"
              label="城市"
            >
              <!-- <span class="merchant-label" slot="label">城市</span> -->
              <el-input v-model="form.cityName" style="width: 200px"></el-input>
            </el-form-item>
            <!-- <el-form-item label-width="80px" label-position="right">
                <span class="merchant-label" slot="label">县/区</span>
                <el-input v-model="form.area" style="width: 200px"></el-input>
              </el-form-item> -->
          </div>
          <!-- </el-form-item> -->
          <el-form-item
            label="酒吧经纬度"
            label-position="right"
            class="form-label"
            prop="coordinate"
          >
            <el-input v-model="form.coordinate"></el-input>
          </el-form-item>
          <el-form-item
            label="酒吧详细地址"
            label-position="right"
            class="form-label"
            prop="detailedAddress"
          >
            <el-input v-model="form.detailedAddress"></el-input>
          </el-form-item>
          <el-form-item
            label="酒吧名称"
            label-position="right"
            class="form-label"
            prop="barName"
          >
            <el-input v-model="form.barName"></el-input>
          </el-form-item>
          <el-form-item
            label="酒吧负责人名字"
            label-position="right"
            class="form-label"
            prop="responsiblePersonName"
          >
            <el-input v-model="form.responsiblePersonName"></el-input>
          </el-form-item>
          <el-form-item
            label="酒吧负责人手机号"
            label-position="right"
            class="form-label"
            prop="responsiblePersonPhone"
          >
            <el-input v-model="form.responsiblePersonPhone"></el-input>
          </el-form-item>
          <el-form-item
            label="酒吧负责人微信号"
            label-position="right"
            class="form-label"
            prop="responsiblePersonWx"
          >
            <el-input v-model="form.responsiblePersonWx"></el-input>
          </el-form-item>
            <el-form-item
            label="酒吧电话"
            label-position="right"
            class="form-label"
            prop="barPhone"
          >
            <el-input v-model="form.barPhone"></el-input>
          </el-form-item>
          <el-form-item
            label="酒吧邮寄地址"
            label-position="right"
            class="form-label"
            prop="mailingAddress"
          >
            <el-input v-model="form.mailingAddress"></el-input>
          </el-form-item>
             <el-form-item
            label="营业时间"
            label-position="right"
            class="form-label"
            prop="businessHours"
          >
            <el-time-picker
              v-model="form.startTime"
              value-format='HH:mm'
              format='HH:mm'
            >
            </el-time-picker>
            -
               <el-time-picker
              v-model="form.endTime"
              value-format='HH:mm'
              format='HH:mm'
            >
            </el-time-picker>
            <!-- <el-input v-model="form.businessHours"></el-input> -->
          </el-form-item>

            <el-form-item
            label="营业时间备注"
            label-position="right"
            class="form-label"
          >
            <el-input
              v-model="form.businessHoursNote"
              placeholder="请填写店休日或特殊营业时间"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="酒头数量"
            label-position="right"
            class="form-label"
            prop="wineHeadNum"
          >
            <el-input v-model="form.wineHeadNum" type="number"></el-input>
          </el-form-item>
          <el-form-item
            label="瓶啤数量"
            label-position="right"
            class="form-label"
            prop="bottlesNum"
          >
            <el-input v-model="form.bottlesNum" type="number"></el-input>
          </el-form-item>
          <el-form-item
            label="特点介绍"
            label-position="right"
            class="form-label"
            prop="featuresIntroduced"
          >
            <el-input v-model="form.featuresIntroduced"  maxlength='200'  
                show-word-limit></el-input>
          </el-form-item>

          <el-form-item
            label="上传营业执照（1张）"
            label-position="right"
            class="form-label"
            prop="businessLicense"
          >
            <el-upload
              class="avatar-uploader"
              :action="imgURL"
              :show-file-list="false"
              :on-success="businessLicenseSuccess"
            >
              <img
                style="width: 100px; height: 100px"
                v-if="form.businessLicense"
                :src="form.businessLicense"
                class="avatar"
              />
              <i
                style="width: 100px; height: 100px"
                v-else
                class="el-icon-plus avatar-uploader-icon"
              ></i>
            </el-upload>
          </el-form-item>

          <el-form-item
            label="上传店铺封面（1张）"
            label-position="right"
            class="form-label"
            prop="cover"
          >
            <el-upload
              class="avatar-uploader"
              :action="imgURL"
              :show-file-list="false"
              :on-success="coverSuccess"
            >
              <img
                style="width: 100px; height: 100px"
                v-if="form.cover"
                :src="form.cover"
                class="avatar"
              />
              <i
                style="width: 100px; height: 100px"
                v-else
                class="el-icon-plus avatar-uploader-icon"
              ></i>
            </el-upload>
          </el-form-item>
          <el-form-item
            label="上传店铺照片（最多9张）"
            label-position="right"
            class="form-label"
            prop="imageVos"
          >
            <el-upload
              :action="imgURL"
              list-type="picture-card"
              :on-remove="handleRemove"
              :on-success="imageSuccess"
              :limit="9"
              :file-list='form.imageVos'
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item
            label="设置登录账号"
            label-position="right"
            class="form-label"
            prop="loginAccount"
          >
            <el-input v-model="form.loginAccount"></el-input>
          </el-form-item>
          <el-form-item
            label="设置登录密码"
            label-position="right"
            class="form-label"
            prop="loginPassword"
          >
            <el-input v-model="form.loginPassword"></el-input>
          </el-form-item>
          <el-form-item
            label="是否提供首次进店优惠"
            label-position="right"
            class="form-label"
            prop="firstTimeDiscount"
          >
            <el-select v-model="form.firstTimeDiscount" placeholder="请选择">
              <el-option label="是" value="是"></el-option>
              <el-option label="否" value="否"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="首次进店优惠政策"
            label-position="right"
            class="form-label"
            prop="preferentialEntryPolicy"
          >
            <el-input
              v-model="form.preferentialEntryPolicy"
              placeholder="如“送瓶啤一杯或者送生啤一杯“"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="长期优惠:"
            label-position="right"
            class="form-label"
            style="margin-bottom: 0"
          >
          </el-form-item>
          <div style="padding-left: 20px">
            <el-form-item
              label="折扣范围"
              label-position="right"
              class="form-label"
              prop="discountsScope"
            >
              <el-select v-model="form.discountsScope" placeholder="请选择">
                <el-option
                  label="全单（含餐饮)"
                  value="全单（含餐饮)"
                ></el-option>
                <el-option
                  label="仅限酒水（瓶啤＋生啤）"
                  value="仅限酒水（瓶啤＋生啤）"
                ></el-option>
                <el-option label="仅限瓶啤" value="仅限瓶啤"></el-option>
                <el-option label="仅限生啤" value="仅限生啤"></el-option>
                <el-option label="仅限自酿" value="仅限自酿"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="折扣力度"
              label-position="right"
              class="form-label"
              prop="discounts"
            >
              <el-input
                v-model="form.discounts"
                placeholder="折扣不低于九折"
                type="number"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="备注"
              label-position="right"
              class="form-label"
             
            >
              <el-input
                v-model="form.note"
                placeholder="您的折扣使用限制/额外的活动（10字）"
                 maxlength='10'
                show-word-limit
              ></el-input>
            </el-form-item>
          </div>
          <el-form-item
            label="你是否愿意给顿友提供打酒壶优惠"
            label-position="right"
            class="form-label"
            prop="isDiscountOnBeaker"
          >
            <el-select v-model="form.isDiscountOnBeaker" placeholder="请选择">
              <el-option label="是" value="是"></el-option>
              <el-option label="否" value="否"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="优惠力度"
            label-position="right"
            class="form-label"
            prop="breaks"
          >
            <el-input v-model="form.breaks" placeholder="请输入" type="number"></el-input>
          </el-form-item>

          <el-form-item label="标签">
            <el-checkbox-group v-model="labels" :max="5">
              <el-checkbox
                :label="item.id"
                 v-for="(item, i) in labesList"
                :key="i"
                >{{ item.name }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="btn">
      <el-button type="primary" @click="addSubmit('form')">提交</el-button>
    </div>
    <!--  坐标选择-->
    <el-dialog title="坐标选择" :visible.sync="coordinate" width="50%" center>
      <div
        class="amap-page-container"
        style="width: 80%; height: 400px; margin: 30px 10%"
      >
        <el-amap-search-box
          class="search-box"
          :search-option="searchOption"
          :on-search-result="onSearchResult"
        ></el-amap-search-box>
        <el-amap
          ref="map"
          vid="amapDemo"
          :amap-manager="amapManager"
          :center="center"
          :zoom="zoom"
          :plugin="plugin"
          :events="events"
          class="amap-demo"
        >
        </el-amap>
        <p>{{ address }}</p>
        <p>{{ center }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="coordinates">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { AMapManager } from "vue-amap";
let amapManager = new AMapManager();
import { labelList, IP, webBarDetail,updateBar } from "@/api/api";

export default {
  data() {
    const self = this;
    return {
      // 标签列表
      labesList: [],
      labels: [],
      adminId: "",
      // 坐标选择
      coordinate: false,
      // 图片上传地址
      imgURL: IP + "/images/uploadImage",
      // imgURL: IP + "/obs/uploadImage",
      form: {
        barName: "",
        responsiblePersonName: "",
        responsiblePersonPhone: "",
        responsiblePersonWx: "",
        city: "",
        cityName: "", //城市
        province: "", //省份
        detailedAddress: "",
        mailingAddress: "",
        businessHours: "",
        wineHeadNum: "",
        bottlesNum: "",
        featuresIntroduced: "",
        cover: "",
        imageList: [],
        loginAccount: "",
        loginPassword: "",
        firstTimeDiscount: "",
        preferentialEntryPolicy: "",
        discountsScope: "",
        discounts: "",
        note: "",
        isDiscountOnBeaker: "",
        breaks: "",
        coordinate: "", //经纬度
        labels: [],
       startTime:'',
        endTime:'',
        businessHoursNote:'',
        businessLicense:'',
        barPhone:'',
      },
      //  高德
      searchOption: {
        city: "", //搜索范围
        citylimit: false, //限制搜索范围
        //city: "", citylimit: false, // 不限制搜索范围搜索，比如想全国搜索
      },
      lng: "",
      lat: "",
      address: "",
      marker: "",
      city: "",
      province: "",
      area: "",
      amapManager,
      zoom: 12,
      center: [121.59996, 31.197646],
      events: {
        init: (o) => {
          o.getCity((result) => {});
        },
        moveend: () => {},
        zoomchange: () => {},
        click: (e) => {
          self.lng = e.lnglat.lng;
          self.lat = e.lnglat.lat;
          self.center = [self.lng, self.lat];
          let o = amapManager.getMap();
          if (!self.marker) {
            self.marker = new AMap.Marker({
              position: e.lnglat,
            });
            self.marker.setMap(o);
          }
          self.marker.setPosition(e.lnglat);
          let geocoder = new AMap.Geocoder({});

          geocoder.getAddress(e.lnglat, function (status, result) {
            console.log("xxxx", result);
            if (status === "complete" && result.regeocode) {
              self.address = result.regeocode.formattedAddress;
              self.city = result.regeocode.addressComponent.city;
              self.province = result.regeocode.addressComponent.province;
            } else {
              log.error("根据经纬度查询地址失败");
            }
          });
        },
      },
      plugin: [
        "ToolBar",
        {
          pName: "MapType",
          defaultType: 0,
          events: {
            init(o) {},
          },
        },
      ],
      plugin: [
        {
          pName: "Geolocation",
          events: {
            init(o) {
              // o 是高德地图定位插件实例
              o.getCurrentPosition((status, result) => {
                // console.log(JSON.stringify(result));
                if (result && result.position) {
                  self.lng = result.position.lng;
                  self.lat = result.position.lat;
                  self.address = result.formattedAddress;
                  self.center = [self.lng, self.lat];
                  //   console.log(self.center, 99666);
                  console.log(result, 99666);
                  console.log(self.city);
                  let o = amapManager.getMap();
                  if (!self.marker) {
                    self.marker = new AMap.Marker({
                      position: self.center,
                    });
                    self.marker.setMap(o);
                  }
                  self.marker.setPosition(self.center);
                }
              });
            },
          },
        },
      ],
      rules: {
        //验证规则
        province: [{ required: true, message: "请输入省份", trigger: "blur" }],
        cityName: [{ required: true, message: "请输入城市", trigger: "blur" }],
        coordinate: [
          { required: true, message: "请输入经纬度", trigger: "blur" },
        ],
        barName: [
          { required: true, message: "请输入酒吧名称", trigger: "blur" },
        ],
        responsiblePersonName: [
          { required: true, message: "请输入酒吧负责人名字", trigger: "blur" },
        ],
        responsiblePersonPhone: [
          {
            required: true,
            message: "请输入酒吧负责人手机号",
            trigger: "blur",
          },
        ],
        responsiblePersonWx: [
          {
            required: true,
            message: "请输入酒吧负责人微信号",
            trigger: "blur",
          },
        ],
         barPhone: [
          {
            required: true,
            message: "请输入酒吧电话",
            trigger: "blur",
          },
        ],
        detailedAddress: [
          { required: true, message: "请输入酒吧详细地址", trigger: "blur" },
        ],
        mailingAddress: [
          { required: true, message: "请输入酒吧邮寄地址", trigger: "blur" },
        ],
   
        wineHeadNum: [
          { required: true, message: "请输入酒头数量", trigger: "blur" },
        ],
        bottlesNum: [
          { required: true, message: "请输入瓶啤数量", trigger: "blur" },
        ],
        featuresIntroduced: [
          { required: true, message: "请输入特点介绍", trigger: "blur" },
        ],
        cover: [{ required: true, message: "请上传店铺封面", trigger: "blur" }],
        imageVos: [
          { required: true, message: "请上传店铺照片", trigger: "blur" },
        ],
        loginAccount: [
          { required: true, message: "请设置登录账号", trigger: "blur" },
        ],
        loginPassword: [
          { required: true, message: "请设置登录密码", trigger: "blur" },
        ],
        firstTimeDiscount: [
          {
            required: true,
            message: "请选择是否提供首次进店优惠",
            trigger: "blur",
          },
        ],
        preferentialEntryPolicy: [
          {
            required: true,
            message: "请输入首次进店优惠政策",
            trigger: "blur",
          },
        ],
        discountsScope: [
          { required: true, message: "请选择折扣范围", trigger: "blur" },
        ],
        discounts: [
          { required: true, message: "请输入折扣力度", trigger: "blur" },
        ],
      
        isDiscountOnBeaker: [
          {
            required: true,
            message: "请选择你是否愿意给顿友提供打酒壶优惠",
            trigger: "blur",
          },
        ],
        breaks: [
          { required: true, message: "请输入优惠力度", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getInfo()
    this.getLabes();
  },
  methods: {
    //  坐标确定
    coordinates() {
      this.form.coordinate = this.lng + "," + this.lat;
      this.form.lng = this.lng;
      this.form.lat = this.lat;
      this.form.cityName = this.city;
      this.form.province = this.province;
      this.form.area = this.area;
      this.form.name = this.name;
      this.form.detailedAddress = this.address;
      this.coordinate = false;
    },

    //  高德地图
    onSearchResult(pois) {
      if (pois.length > 0) {
        let { lng, lat, name, location } = pois[0];
        let center = [lng, lat];
        this.lng = lng;
        this.lat = lat;
        this.center = [lng, lat];
        this.name = name;
        let o = amapManager.getMap();
        if (!this.marker) {
          this.marker = new AMap.Marker({
            position: center,
          });
          this.marker.setMap(o);
        }
        this.marker.setPosition(center);
        // 近来补充  根据经纬度查询地址
        let geocoder = new AMap.Geocoder({});
        let that = this;
        geocoder.getAddress(location, function (status, result) {
          if (status === "complete" && result.regeocode) {
            that.address = result.regeocode.formattedAddress;
            console.log(result);
            that.city = result.regeocode.addressComponent.city;
            that.province = result.regeocode.addressComponent.province;
            that.area = result.regeocode.addressComponent.district;
          } else {
            console.log("根据经纬度查询地址失败");
          }
        });
      }
    },
  //  获取酒吧信息
 async getInfo(){
   let res=await webBarDetail({
     barId:this.$route.query.barId
   })
   console.log(res)
   if(res.code==200){
     res.data.firstTimeDiscount=res.data.firstTimeDiscount==true?'是':'否'
     res.data.isDiscountOnBeaker=res.data.isDiscountOnBeaker==true?'是':'否'
     res.data.businessHours=res.data.businessHours
        // startTime:'',
        // endTime:'',
        res.data.startTime=res.data.businessHours.split(',')[0]
        res.data.endTime=res.data.businessHours.split(',')[1]
     this.labels=res.data.labels.map(item=>{
       return item.id
     })
     this.form=res.data
     console.log( this.labels)
    //  this.imageVos=res.data.imageVos
   }
  },

    // 上传营业执照
    businessLicenseSuccess(e) {
      console.log(e);
      this.form.businessLicense = e;
    },


    // 上传店铺图片
    coverSuccess(e) {
      console.log(e);
      this.form.cover = e;
    },
    // 上传店铺照片
    imageSuccess(e) {
      console.log(e);
      this.form.imageVos.push({url:e});
    },
    // 删除店铺照片
    handleRemove(e) {
      console.log(e)
      this.form.imageVos.forEach((item, i) => {
        if (item.url == e.response||item.url==e.url) {
          this.form.imageVos.splice(i, 1);
        }
      });
      console.log(e);
    },
    // 标签列表
    async getLabes() {
      let res = await labelList();
      console.log(res);
      if (res.code == 200) {
        this.labesList = res.data;
      }
    },
    // 提交
    addSubmit(formName) {
         if(this.form.startTime==''){
           this.$message({
            type: "danger",
            message: "营业开始时间不能为空",
          });
         return false
      }
      if(this.form.endTime==''){
           this.$message({
            type: "danger",
            message: "营业结束时间不能为空",
          });
         return false
      }
      this.form.businessHours=''
      this.form.businessHours=this.form.startTime+','+this.form.endTime
      this.form.labels = [];
      this.labels.forEach((item) => {
        this.labesList.forEach((obj) => {
          if (item == obj.id) {
            this.form.labels.push(obj);
          }
        });
      });
  
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
            this.form.firstTimeDiscount=this.form.firstTimeDiscount=='是'?true:false
             this.form.isDiscountOnBeaker=this.form.isDiscountOnBeaker=='是'?true:false
          let res = await updateBar(this.form);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "修改成功",
            });
            this.$router.push("barList");
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.addActivities {
  background: #fff;
  height: 100%;
  padding: 15px;
  box-sizing: border-box;
  overflow-y: scroll;
  .main {
    padding: 30px 0px;
    // width: 50%;
    .form-img {
      display: flex;
      .imgs {
        width: 40px;
        height: 40px;
      }
    }
  }
  .merchant {
    padding: 30px 0px;
    width: 70%;

    .form-img {
      display: flex;

      .imgs {
        width: 40px;
        height: 40px;
      }
    }
    .coordinate {
      display: flex;
      align-items: center;
      .el-form-item {
        margin-right: 30px;
      }
      .merchant-label {
        display: inline-block;
        width: 80px;
        height: 40px;
        background: #e6e6e6;
        text-align: center;
      }
    }
  }
  .gather {
    padding: 30px 0px;
    width: 50%;
  }
  .btn {
    padding: 0 50px;
    button {
      width: 200px;
    }
  }
}
.search-box {
  position: absolute;
  top: 25px;
  left: 20px;
}
.amap-page-container {
  position: relative;
}
/deep/ .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
/deep/ .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
/deep/ .avatar {
  width: 100px;
  height: 100px;
  display: block;
}
/deep/.el-upload--picture-card {
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    width: 100px;
    height: 100px;
    line-height: 100px;
    vertical-align: top;
}
/deep/.el-upload-list--picture-card .el-upload-list__item {
    overflow: hidden;
    background-color: #fff;
    border: 1px solid #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    width: 100px;
    height: 100px;
    margin: 0 8px 8px 0;
    display: inline-block;
}
/deep/.el-upload-list__item-thumbnail{
   width: 100px;
    height: 100px;
} 
</style>